/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, BoxProps } from "@mui/material";
import { SVGProps } from "react";

type LogoNameProps = BoxProps & SVGProps<SVGElement>;

export default function LogoName({ width = 411, height = 55, ...props }: LogoNameProps) {
  return (
    <Box
      component={"svg"}
      width={width}
      height={height}
      viewBox="0 0 411 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={"Legalbird"}
      {...props}
    >
      <path d="M0.00525886 53.9759V0.558594H3.62008V50.2716H33.9699V53.9759H0H0.00525886Z" fill="#595757" />
      <path d="M42.9094 53.9759V0.558594H79.4996V4.26287H46.4558V24.3522H75.7427V27.9776H46.4558V50.2769H79.8574V53.9811H42.9094V53.9759Z" fill="#595757" />
      <path
        d="M130.411 49.5604C126.059 52.8701 120.84 54.5223 114.736 54.5223C106.696 54.5223 100.34 52.2123 95.6623 47.5873C90.7899 42.8096 88.3589 36.0851 88.3589 27.419C88.3589 18.7529 90.6846 12.2809 95.3413 7.36645C99.9979 2.45724 106.296 0 114.242 0C120.15 0 125.065 1.31543 128.99 3.94105C133.431 6.93498 136.32 11.8968 137.646 18.8318H133.952C131.874 8.74503 125.323 3.70428 114.31 3.70428C107.406 3.70428 101.961 5.80897 97.9669 10.0078C93.968 14.212 91.9738 19.9894 91.9738 27.3401C91.9738 34.6907 93.9943 40.6418 98.0353 44.7144C102.076 48.787 107.643 50.8232 114.731 50.8232C120.166 50.8232 124.776 49.2763 128.559 46.1719C132.626 42.8622 134.662 38.4792 134.662 33.0175V31.5968H114.026V27.8925H138.135C138.277 29.6237 138.351 31.018 138.351 32.0704C138.351 39.6841 135.699 45.5141 130.406 49.5604H130.411Z"
        fill="#595757"
      />
      <path
        d="M190.258 53.9759L183.381 37.1909H157.714L150.695 53.9759H146.58L169.127 0.558594H172.463L194.231 53.9759H190.258ZM170.827 6.38862L159.266 33.413H181.887L170.827 6.38862Z"
        fill="#595757"
      />
      <path d="M203.019 53.9759V0.558594H206.634V50.2716H236.989V53.9759H203.019Z" fill="#595757" />
      <path
        d="M268.403 53.9759H245.356V0.558594H269.324C273.812 0.558594 277.5 1.632 280.384 3.78932C283.688 6.25708 285.346 9.8561 285.346 14.5812C285.346 19.6798 282.746 23.4577 277.542 25.9255C283.783 27.9197 286.908 32.308 286.908 39.0851C286.908 44.3416 284.898 48.2511 280.878 50.8241C277.616 52.9235 273.454 53.9759 268.398 53.9759H268.403ZM269.182 4.2576H248.971V24.347H269.113C272.612 24.347 275.496 23.5893 277.763 22.0634C280.41 20.2796 281.731 17.654 281.731 14.1813C281.731 10.7085 280.357 8.11447 277.616 6.38336C275.396 4.96268 272.581 4.2576 269.176 4.2576H269.182ZM268.971 28.0512H248.976V50.2716H269.26C273.186 50.2716 276.401 49.4298 278.905 47.7513C281.883 45.8097 283.372 42.9473 283.372 39.1641C283.372 35.1178 281.789 32.1502 278.626 30.2612C276.164 28.7932 272.954 28.0565 268.982 28.0565L268.971 28.0512Z"
        fill="#595757"
      />
      <path d="M298.536 53.9759V0.558594H302.151V53.9759H298.536Z" fill="#595757" />
      <path
        d="M347.043 27.8928C352.005 30.0449 354.489 34.2227 354.489 40.421V53.97H350.874V40.5736C350.874 33.5913 346.475 30.0975 337.683 30.0975H318.745V53.97H315.131V0.552734H338.319C349.574 0.552734 355.199 5.23044 355.199 14.5753C355.199 21.0894 352.479 25.5303 347.043 27.8928ZM338.461 4.25701H318.745V26.2406H337.325C341.387 26.2406 344.649 25.3987 347.112 23.7202C350.09 21.726 351.579 18.7584 351.579 14.8173C351.579 7.77713 347.206 4.25701 338.461 4.25701Z"
        fill="#595757"
      />
      <path
        d="M384.412 53.9759H367.748V0.558594H387.106C394.999 0.558594 401.003 2.94743 405.117 7.73036C409.043 12.3502 411 18.8905 411 27.3462C411 35.8018 408.495 42.7631 403.486 47.4355C398.809 51.7975 392.447 53.9759 384.412 53.9759ZM402.492 10.4033C399.04 6.30968 393.889 4.2576 387.033 4.2576H371.358V50.2716H384.618C391.805 50.2716 397.393 48.33 401.392 44.4416C405.386 40.5584 407.385 34.86 407.385 27.3462C407.385 19.8324 405.754 14.2391 402.492 10.4086V10.4033Z"
        fill="#595757"
      />
    </Box>
  );
}
